module.exports = __webpack_public_path__ + "static/4-a6cb726d9229785c3917c4054c26de64.png";